export enum URL_API {
  LOGIN = "https://c2vietnam.com/api/login",
  SCAN = "https://c2vietnam.com/api/check_code",
}
